import React from 'react';
import { Form } from 'react-bootstrap';

const EnableDaysOfWeekSwitch = ({ enabled, onChange }) => (
  <div className="d-flex justify-content-between align-items-center mb-2">
    <Form.Label htmlFor="enable-days-of-week" className="fw-bold text-white mb-1 mb-0">
      Enable Days of Week
    </Form.Label>
    <Form.Check
      type="switch"
      id="enable-days-of-week"
      label=""
      checked={enabled}
      onChange={onChange}
      className="ms-2"
    />
  </div>
);

export default EnableDaysOfWeekSwitch;
